import { WebPlugin } from '@capacitor/core';
export class PlacePickerWeb extends WebPlugin {
    async pickPlace(_) {
        return JSON.stringify(_);
    }
}
//# sourceMappingURL=web.js.map